import { RootState } from '@redux/hooks';

export const selectPermissions = (state: RootState) => {
  return state['accounts'].permissions;
};
